// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iZhn","field":"styles_field__OC7Lv","fieldCol":"styles_fieldCol__3QxXB","diffCol":"styles_diffCol__38jjx","diff":"styles_diff__Ohe12"};